import httpClient from "@/common/http-client";

const selectPrivacyPolicy = (params) => {
  return httpClient.get("/api/policy/privacyPolicy/"+params.applyDt, params, { headers: { "show-layer": "Yes" } });
};

export default {
  selectPrivacyPolicy
};
